import script from "./GeneralView.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralView.vue?vue&type=script&setup=true&lang=js"

import "./GeneralView.vue?vue&type=style&index=0&id=0a0c5fdb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0c5fdb"]])

export default __exports__